import { defineStore } from 'pinia'

export type INavigationState = {
  tempSurvey: null
  tempReport: null
  tempEncounter: null
  tempReportEoc: any | null
  tempPath: null
  currentPath: any | null
  logingOut: boolean
  capability: any | null
  context: 'web' | 'external' | 'embed'
}

export const useNavigationStore = defineStore('navigation', {
  state: (): INavigationState => {
    return {
      tempSurvey: null,
      tempReport: null,
      tempReportEoc: null,
      tempEncounter: null,
      tempPath: null,
      capability: { isPatientCreation: false },
      currentPath: null,
      logingOut: false,
      context: 'web', // web || embed || external
    }
  },
  getters: {
    embed: (state) => state.context === 'embed',
    external: (state) => state.context === 'external',
    redirection: (state) => {
      if (state.tempPath) return state.tempPath
      if (state.tempSurvey) return state.tempSurvey
      if (state.tempReport) return state.tempReport
    },
    reportEoc: (state) => {
      if (state.tempReportEoc) return state.tempReportEoc
    },
  },
  actions: {
    setEmbedContext() {
      this.context = 'embed'
    },
    setCapability(c: any) {
      this.capability = c
    },
    setExternalContext() {
      this.context = 'external'
    },
    addReportEoc(eoc: any) {
      this.tempReportEoc = eoc
    },
    addSurvey(survey: any) {
      this.tempSurvey = survey
    },
    addReport(report: any) {
      this.tempReport = report
    },
    addEncounter(encounter: any) {
      this.tempEncounter = encounter
    },
    addTempPath(path: any) {
      this.tempPath = path
    },
    setCurrentPath(path: any) {
      this.$patch({ currentPath: path })
    },
    /**
     * An action to clear the user data from the storage, should be used upon signing out the user.
     *
     * @param {object} context - VueX store context containing commit helper for mutations.
     */
    clear() {
      this.$reset()
    },
  },
})
